// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1x-Xw","box":"WorkspacesBox_box__1mv2M","node":"WorkspacesBox_node__17Z8d"};